import { useHirerAuth } from '@seek/hirer-auth-react';
import { useEffect } from 'react';

import { useRedirectURL } from 'src/App/context/Authentication/useRedirectURL';

import { LoadingBlock } from '../../pages/ad-budget-selection/components/Loading/Loading.tsx';

export const Authenticate: React.FC<
  React.PropsWithChildren & { isLocalAuth: boolean }
> = ({ children, isLocalAuth }) => {
  const { authenticated, loading, login } = useHirerAuth();

  const { origin, pathname, search } = useRedirectURL();

  useEffect(() => {
    if (loading || isLocalAuth) {
      return;
    }

    if (!authenticated) {
      // TODO : We will need to migrate to use the useAuthenticator, as requested by HSS. However, since it has a current issue regarding not using canonicalURL for hirer login, and also not being able to pass in a canonicalLocation object like login(),
      // we will maintain this for now since we have a specific usecase of redirecting un-authed visitors that selected a budget, directly to checkout page after login
      login({
        location: {
          origin,
          pathname,
          search,
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, authenticated]);

  if (isLocalAuth) {
    return <>{children}</>;
  }

  if (loading && !authenticated) {
    return <LoadingBlock />;
  }

  return <>{children}</>;
};
